import { render, staticRenderFns } from "./metricItem.vue?vue&type=template&id=6b4c7fca&scoped=true&"
import script from "./metricItem.vue?vue&type=script&lang=js&"
export * from "./metricItem.vue?vue&type=script&lang=js&"
import style0 from "./metricItem.vue?vue&type=style&index=0&id=6b4c7fca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4c7fca",
  null
  
)

export default component.exports